module.exports = __webpack_public_path__ + "static/img/updateTitle.8cffec58.png";